import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allServiceReports } from 'app/mocks/data/reports/service'

import { api } from 'app/utils/constants'

import { StatusReport } from 'app/types/reports'
import { ServiceReport } from 'app/types/reports/service'

export const getServiceReport = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.reports.service.DETAILS}`,
    ({ params }) => {
        const { id } = params

        const serviceReportFound: ServiceReport = allServiceReports.find(
            (service) => service.id.toString() === id,
        )

        // Not found
        if (!serviceReportFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        // Not generated
        if (serviceReportFound.status === StatusReport.enum.IN_PROGRESS) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.CONFLICT,
            })
        }

        return HttpResponse.json<ServiceReport>(serviceReportFound)
    },
)
